var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenPhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9994 15.9739V18.9846C21.0005 19.2641 20.943 19.5408 20.8308 19.7968C20.7187 20.053 20.5541 20.2828 20.3478 20.4719C20.1414 20.6608 19.8978 20.8046 19.6325 20.8943C19.3672 20.9837 19.0861 21.017 18.8072 20.9919C15.7127 20.6563 12.7404 19.601 10.1289 17.9108C7.69919 16.3699 5.63924 14.3141 4.09533 11.8892C2.39585 9.27098 1.33823 6.29007 1.00816 3.18793C0.983035 2.9104 1.01607 2.6307 1.1052 2.36662C1.19433 2.10253 1.33756 1.85986 1.5258 1.65406C1.71405 1.44824 1.94316 1.28382 2.19858 1.17122C2.45398 1.05864 2.73008 1.00035 3.00928 1.0001H6.02605C6.51409 0.995298 6.9872 1.16777 7.35723 1.48537C7.72725 1.80295 7.96894 2.24401 8.03725 2.72628C8.16457 3.6898 8.40072 4.63586 8.74115 5.5464C8.87644 5.90562 8.90574 6.296 8.82554 6.67133C8.74534 7.04663 8.55901 7.39112 8.28865 7.664L7.01154 8.93858C8.44305 11.4511 10.5275 13.5315 13.045 14.9603L14.3221 13.6855C14.5956 13.4157 14.9409 13.2299 15.3169 13.1497C15.6929 13.0697 16.0841 13.099 16.4439 13.2339C17.3563 13.5737 18.3043 13.8094 19.2698 13.9364C19.7581 14.0054 20.2043 14.2508 20.5232 14.6264C20.8421 15.0021 21.0116 15.4817 20.9994 15.9739Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPhoneIcon);
export default __webpack_public_path__ + "static/media/greenPhoneIcon.fc85c5232b9cc8212a60cf2a490d450e.svg";
export { ForwardRef as ReactComponent };